/** @format */

import React from 'react';
import GridItem from '../../../../components/Grid/GridItem';
import InputFormRest from '../../../../components/Form/InputFormRest';
import { FormGeneralHelper } from '../../../../helpers/FormGeneral';

interface IccidFormProps {
    handleChangeMultiple: (event: any) => void;
    changeInput: (event: any, stateName: string) => void;
    iccidFrom: string;
    iccidTo: string;
}

const IccidForm = (props: IccidFormProps): React.ReactElement => {
    return (
        <>
            <GridItem xs={4}>
                <InputFormRest
                    callback={props.changeInput}
                    stateName={'iccidFrom'}
                    stateObjectState={''}
                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                    typeField={FormGeneralHelper.TYPE_TEXT}
                    displayFieldName={'specialized_report:h.iccid_from'}
                    vMax={256}
                    vMin={-1}
                    required={true}
                    value={props.iccidFrom}
                />
            </GridItem>
            <GridItem xs={4}>
                <InputFormRest
                    callback={props.changeInput}
                    stateName={'iccidTo'}
                    stateObjectState={''}
                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                    typeField={FormGeneralHelper.TYPE_TEXT}
                    displayFieldName={'specialized_report:h.iccid_to'}
                    vMax={256}
                    vMin={-1}
                    required={true}
                    value={props.iccidTo}
                />
            </GridItem>
        </>
    );
};

export default IccidForm;
